import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import dashboard from "../../assets/images/homePage/Dashboard.png"
import leadManagement from "../../assets/images/homePage/lead-management.png"
import reviewManagement from "../../assets/images/homePage/review-mngmnt.png"
import emailComm from "../../assets/images/homePage/email-thread.png"
import hotelLeadCapture from "../../assets/images/homePage/hotel-lead-capture.png";
import leadManagementHome from "../../assets/images/homePage/lead-management-home.png";
import ArrowImage from "../../assets/images/homePage/filled-arrow.png";

const AboutSection = () => {
  const customGridTemplateColumns = "repeat(2, 1fr)";
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: "Dashboard",
      content: (
        <div className="grid-auto-fit max-width950">
          <div className="text-left">
            <h3 className="roboto-bold heading20px mb10">
              Dashboard
            </h3>
            <p className="roboto-regular heading16px mb20">
              Get a real-time, centralized view of your hotel’s sales, marketing, and reputation performance to drive smarter decisions and faster action.
            </p>

            <ul className="home-tabs-content">
              <li className="roboto-regular heading16px">
                Monitor leads, campaigns, and pipeline progress with live insights.
              </li>
              <li className="roboto-regular heading16px">
                Track guest reviews and sentiment using the built-in Reputation Manager.
              </li>
              <li className="roboto-regular heading16px">
                Analyze performance metrics with intuitive visuals and filters.
              </li>
            </ul>

            {/* <NavLink
              to={"/sales"}
              className="common-btn-class main-btn-primary roboto-regular mt20"
              style={{ borderRadius: "28px" }}
            >
              Learn More &nbsp;{" "}
              <img
                src={ArrowImage}
                alt="Arrow"
                className="img-responsive"
                loading="lazy"
                style={{ height: "24px", width: "24px" }}
              />{" "}
            </NavLink> */}
          </div>
          <div>
            <img
              src={dashboard}
              alt="Sales Professionals"
              className="img-responsive"
              loading="lazy"
            />
          </div>
        </div>
      ),
    },
    {
      label: "Lead Management",
      content: (
        <div className="grid-auto-fit max-width950">
          <div className="text-left">
            <h3 className="roboto-bold heading20px mb10">AI Driven lead and guest engagement</h3>
            <p className="roboto-regular heading16px mb20">
              Capture, manage, and convert high-quality leads with powerful tools designed for hotel sales teams.
            </p>

            <ul className="home-tabs-content">
              <li className="roboto-regular heading16px">
                Streamline lead capture with web-to-lead forms and custom forms.
              </li>
              <li className="roboto-regular heading16px">
                Automatically convert data to actionable leads and track their journey.
              </li>
              <li className="roboto-regular heading16px">
                Manage leads efficiently with a kanban pipeline view and customizable stages.
              </li>
            </ul>

            <NavLink
              to={"/lead-management"}
              className="common-btn-class main-btn-primary roboto-regular mt20"
              style={{ borderRadius: "28px" }}
            >
              Learn More &nbsp;{" "}
              <img
                src={ArrowImage}
                alt="Arrow"
                className="img-responsive"
                loading="lazy"
                style={{ height: "24px", width: "24px" }}
              />{" "}
            </NavLink>
          </div>
          <div>
            <img
              src={leadManagement}
              alt="Marketing"
              className="img-responsive"
              loading="lazy"
            />
          </div>
        </div>
      ),
    },
    {
      label: "Review Management",
      content: (
        <div className="grid-auto-fit max-width950">
          <div className="text-left">
            <h3 className="roboto-bold heading20px mb10">AI powered review management</h3>
            <p className="roboto-regular heading16px mb20">
              Stay on top of guest feedback and build a stronger online reputation with centralized review tools.
            </p>

            <ul className="home-tabs-content">
              <li className="roboto-regular heading16px">
                Manage reviews from Google and major OTA platforms in one place.
              </li>
              <li className="roboto-regular heading16px">
                Respond faster using pre-built templates and unified review threads.
              </li>
              <li className="roboto-regular heading16px">
                Gain insights into guest sentiment to improve service quality.
              </li>
            </ul>

            {/* <NavLink
              to={"/recruiting"}
              className="common-btn-class main-btn-primary roboto-regular mt20"
              style={{ borderRadius: "28px" }}
            >
              Learn More &nbsp;{" "}
              <img
                src={ArrowImage}
                alt="Arrow"
                className="img-responsive"
                loading="lazy"
                style={{ height: "24px", width: "24px" }}
              />{" "}
            </NavLink> */}
          </div>
          <div>
            <img
              src={reviewManagement}
              alt="Recruitment"
              className="img-responsive"
              loading="lazy"
            />
          </div>
        </div>
      ),
    },
    {
      label: "Email Communication",
      content: (
        <div className="grid-auto-fit max-width950">
          <div className="text-left">
            <h3 className="roboto-bold heading20px mb10">Email Communication</h3>
            <p className="roboto-regular heading16px mb20">
              Engage leads with personalized conversations through a unified, professional-grade email experience.
            </p>

            <ul className="home-tabs-content">
              <li className="roboto-regular heading16px">
                Send and receive emails directly from the platform with native integration.
              </li>
              <li className="roboto-regular heading16px">
                View complete conversation history for better context and follow-ups.
              </li>

              <li className="roboto-regular heading16px">
                Enhance engagement with threaded emails tailored to each lead.
              </li>
            </ul>

            {/* <NavLink to={""} className="common-btn-class main-btn-primary roboto-regular mt20" style={{ borderRadius: '28px' }}>Learn More &nbsp; <img src={ArrowImage} alt="Arrow" className="img-responsive" loading="lazy" style={{ height: '24px', width: '24px' }} /> </NavLink> */}
          </div>
          <div>
            <img
              src={emailComm}
              alt="Research"
              className="img-responsive"
              loading="lazy"
            />
          </div>
        </div>
      ),
    },

  ];

  // Use effect to change the tab every 4 seconds
  // useEffect(() => {
  //     const interval = setInterval(() => {
  //         setActiveTab((prevTab) => (prevTab + 1) % tabs.length);
  //     }, 3000);

  //     // Cleanup interval on component unmount
  //     return () => clearInterval(interval);
  // }, [tabs.length]);

  return (
    <>
      <section className="aboutWrapper _border-bottom">
        <div className="max-container">
          <div className="padd-90">
            <div
              className="grid-auto-fit align-items-center mb60 max-width950"
              style={{ "--grid-gap": "60px" }}
            >
              <div className="company-search-etc">
                <p className="text-primary-color heading16px roboto-regular mb10">
                  <strong>
                    Lead Management Made Simple
                  </strong>
                </p>
                <h2 class="heading29px roboto-bold mb10">
                  Capture, Nurture, Convert!
                </h2>
                <p className="roboto-regular heading16px mb10">
                  Effortlessly Capture, Nurture, and Convert Leads with our
                  integrated lead management. From seamless lead acquisition to
                  personalized nurturing and higher conversion rates, streamline
                  your sales journey like never before.
                </p>

                <ul class="points-ul mt30">
                  <li class="heading16px roboto-regular">
                    <strong>Effortless Lead Capture</strong> <br /> Instantly
                    capture valuable customer details from various sources.
                  </li>
                  <li class="heading16px roboto-regular">
                    <strong>Streamlined Tracking</strong> <br /> Keep every lead
                    organized, ensuring no opportunity is missed.
                  </li>
                </ul>

                <NavLink
                  to={"/signup"}
                  className="common-btn-class main-btn-primary roboto-regular mt30"
                >
                  Start Now
                </NavLink>
              </div>
              <div>
                <img
                  src={leadManagementHome}
                  alt="Capture, Nurture, Convert!"
                  className="img-responsive"
                  loading="lazy"
                />
              </div>
            </div>

            <div
              className="grid-auto-fit align-items-center mb60 max-width950"
              style={{ "--grid-gap": "60px" }}
            >
              <div className="block-order2">
                <img
                  src={hotelLeadCapture}
                  alt="Online Channels"
                  className="img-responsive"
                  loading="lazy"
                />
              </div>
              <div className="company-search-etc">
                <p className="text-primary-color heading16px roboto-regular mb10">
                  <strong>
                    Capture More Leads. Book More Stays
                  </strong>
                </p>

                <h2 className="heading29px roboto-bold mb10">
                  Simplify, Delight, Excel!
                </h2>
                <p className="heading16px roboto-regular">
                  Integrate bookings from various OTAs and channels, automate
                  queries, and track guest preferences to deliver personalized
                  experiences. Simplify lead management and elevate guest
                  satisfaction effortlessly.
                </p>

                <ul class="points-ul mt30">
                  <li class="heading16px roboto-regular">
                    <strong>Integrated Solutions</strong> <br /> Streamline
                    Operations Tailored for the travel and Hospitality Industry.
                  </li>
                  <li class="heading16px roboto-regular">
                    <strong>Enhanced Guest Experience</strong> <br /> Deliver
                    personalized service and seamless interactions to elevate
                    every guest's stay.
                  </li>
                </ul>

                <NavLink
                  to={"/signup"}
                  className="common-btn-class main-btn-primary roboto-regular mt30"
                >
                  Book Smarter
                </NavLink>
              </div>
            </div>

            <div className="_blank60px">&nbsp;</div>

            <div className="tabs-wrapper">
              <h2 className="roboto-bold mb10 heading29px text-center ">
                Transform Inquiries into Bookings
              </h2>

              <p className="heading16px roboto-regular text-center mb30">Never miss an opportunity with our comprehensive lead management system <br /> designed specifically for hospitality businesses.</p>

              <div className="App">
                <div className="tabs">
                  <div className="tab-buttons">
                    {tabs.map((tab, index) => (
                      <button
                        key={index}
                        onClick={() => setActiveTab(index)}
                        className={`tab ${activeTab === index ? "active" : ""}`}
                      >
                        {tab.label}
                      </button>
                    ))}
                  </div>
                  <div className="tab-content">{tabs[activeTab].content}</div>
                </div>
              </div>
            </div>

            {/* <div className="_blank60px">&nbsp;</div>

                        <h2 className="roboto-bold mb10 heading29px text-center mb10">10x Your Insights, <br /> With Data that Fits</h2>
                        <p className="roboto-regular heading16px mb10 text-center">We have more than 10M+ Companies and 90M+ High Professionals</p>
                        <img src={DataFitsImage} alt="10x Your Insights, With Data that Fits" className="img-responsive" loading="lazy" /> */}
          </div>
        </div>
      </section>
    </>
  );
};
export default AboutSection;
